import React from 'react';
import { createSvgIcon } from '@mui/material';

export const DirectoryShowrunnrFilter = createSvgIcon(
    <>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 15.0801H12.2473L14 17.0001H0V15.0801Z" fill="#41A441" />
            <rect x="3.90454" y="6.45325" width="14.0955" height="1.91997" fill="#E31E0D" />
            <path d="M8.34497 12.1525H10L11.8 14.2276H8.34497V12.1525Z" fill="#1CA1BF" />
            <rect x="2.23999" y="9.22528" width="7.65088" height="2.0751" fill="#F0E22A" />
            <path
                d="M11.9596 11.6075C13.4829 13.55 16.2956 17.15 16.2956 17.15V21.65C16.2956 22.0625 16.635 22.4 17.0497 22.4H18.5579C18.9727 22.4 19.312 22.0625 19.312 21.65V17.15C19.312 17.15 22.1172 13.55 23.6405 11.6075C24.0251 11.1125 23.6706 10.4 23.0448 10.4H12.5553C11.9295 10.4 11.575 11.1125 11.9596 11.6075Z"
                fill="currentColor"
                fillOpacity="0.56"
            />
        </svg>
    </>,
    'DirectoryShowrunnrFilter'
);
